import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Routes as AppRoutes } from 'src/app/constantes/routes.enum';
import { CoordonneesComponent } from '@components/coordonnees/coordonnees.component';
import { PageErreurComponent } from '@components/page-erreur/page-erreur.component';
import { ModifierAdresseComponent } from '@components/modifier-adresse/modifier-adresse.component';
import { ModifierCourrielComponent } from '@components/modifier-courriel/modifier-courriel.component';
import { ModifierTelephoneComponent } from '@components/modifier-telephone/modifier-telephone.component';
import { PageValidationCourrielComponent } from '@components/page-validation-courriel/page-validation-courriel.component';
import { PageValidationTelephoneComponent } from '@components/page-validation-telephone/page-validation-telephone.component';
import { PageValidationAdresseComponent } from '@components/page-validation-adresse/page-validation-adresse.component';
import { FinParcoursComponent } from '@components/fin-parcours/fin-parcours.component';
import { PageConfirmationAdresseComponent } from '@components/page-confirmation-adresse/page-confirmation-adresse.component';
import { PageConfirmationCourrielComponent } from '@components/page-confirmation-courriel/page-confirmation-courriel.component';
import { PageConfirmationTelephoneComponent } from '@components/page-confirmation-telephone/page-confirmation-telephone.component';
import { RefreshGuardService } from '@services/guard/refresh-guard.service';

const routeCoordonnee: Routes = [
  {
    path: AppRoutes.COORDONNEES,
    component: CoordonneesComponent,
  },
  {
    path: AppRoutes.MODIFIER_ADRESSE,
    component: ModifierAdresseComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.MODIFIER_TELEPHONE,
    component: ModifierTelephoneComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.MODIFIER_COURRIEL,
    component: ModifierCourrielComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.CONFIRMATION_ADRESSE,
    component: PageConfirmationAdresseComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.CONFIRMATION_COURRIEL,
    component: PageConfirmationCourrielComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.CONFIRMATION_TELEPHONE,
    component: PageConfirmationTelephoneComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.VALIDATION_COURRIEL,
    component: PageValidationCourrielComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.VALIDATION_TELEPHONE,
    component: PageValidationTelephoneComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.VALIDATION_ADRESSE,
    component: PageValidationAdresseComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.ERREUR,
    component: PageErreurComponent,
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.FIN_PARCOURS,
    component: FinParcoursComponent,
    canActivate: [RefreshGuardService],
  },
  { path: AppRoutes.ANY, redirectTo: AppRoutes.COORDONNEES, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routeCoordonnee)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
